import React from 'react';
import {
  Box,
  BoxProps,
  IconButtonProps,
  Theme,
  withStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import FsIconButton from 'ui-elements/buttons/FsIconButton';
import defaultLocales from 'globals/locales/default';

export const UpperContainerBox = withStyles(
  ({ breakpoints, palette }: Theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderBottom: `1px solid ${palette.grey[200]}`,
      [breakpoints.up('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    },
  })
)((props: BoxProps) => <Box {...props} />);

export const ChartContainerBox = withStyles(() => ({
  root: {
    overflowX: 'auto',
    '& svg path[clip-path]': {
      // overwrite default chart styles, add transition
      transition: `stroke .3s linear`,
    },
  },
}))((props: BoxProps) => <Box {...props} />);

export const AddButton = withStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(2),
  },
}))((props: IconButtonProps) => (
  <Box>
    <FsIconButton size="medium" aria-label={defaultLocales.add} {...props}>
      <AddIcon fontSize="large" />
    </FsIconButton>
  </Box>
));
